import React, { useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Input from 'components/Input';
import Button from 'components/Button';

import useNotificationsCustom from 'features/creativeFunctionality/models/notificationsCustomModel';

import NotificationsCustomItem from './NotificationsCustomItem';

import './NotificationsCustom.scss';

const b = block('notifications-custom-desktop');

const NotificationsCustom = () => {
  const locale = useSelector(state => state.locale.locale);

  const model = useNotificationsCustom();

  return (
    <div className={b()}>
      <div className={b('header')}>
        <div className={b('title')}>{locale.notifications}</div>
        <div className={b('counter')}>
          {locale.totalNotifications}: {model.values.notifyRequests.count}
        </div>
      </div>
      <div className={b('send-text')}>
        <div className={b('send-text-title')}>{locale.notificationText}</div>
        <div className={b('send-text-input')}>
          <Input
            value={model.values.notificationText}
            onChange={model.handlers.handleSetNotificationText}
            placeholder={locale.enterNotificationText}
          />
        </div>
        <div className={b('send-text-button')}>
          <Button text={locale.sendToConfirm} callBack={model.handlers.handleCreateCustomNotification} />
        </div>
      </div>
      <div className={b('items')}>
        {model.values.notifyRequests.items.map(item => (
          <NotificationsCustomItem
            item={item}
            key={item.id}
            handleGetNotificationsRequest={model.handlers.handleGetNotificationsRequest}
          />
        ))}
      </div>
    </div>
  );
};

export default NotificationsCustom;
